import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Link } from 'react-router-dom';
import RequestApi from '../../Miscelania/RequestApi';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import DatePicker from 'react-datepicker';
import getLocale from '../../../i18n/getLocale';

class StaffHoursTab extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      flight_hours_totals: [],
      staff_flight_files: [],
      name: '',
      archive: '',
      date_start: '',
      id: '',
    };
    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionarArquivo = this.adicionarArquivo.bind(this);
    this.botaoDownloadArquivo = this.botaoDownloadArquivo.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);

    this.locale = getLocale();
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  }   

  // LM
  // Setamos o state.date para a data de hoje
  componentWillMount () {
      var today = new Date().toISOString().slice(0,10);
      var today_str = new Date().toJSON().slice(0,10).split('-').reverse().join('/');

      this.setState({date_start: today_str});
  }
  
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.flight_hours_totals)) {
      this.setState({
        flight_hours_totals: newProps.flight_hours_totals,
      });
    }
    if(typeof newProps.staff_id !== 'undefined') {
      this.setState({
        id: newProps.staff_id,
      });
    }
    if(Array.isArray(newProps.staff_flight_files)) {
      this.setState({staff_flight_files: newProps.staff_flight_files});
    }
  }


  adicionarArquivo(event) {
    event.preventDefault();
    var data = new FormData();
    var imagedata = document.querySelector(".input-archive-flight-files").files[0];
    data.append("name", this.state.name);
    data.append("date_start", this.state.date_start);
    data.append("imagem", imagedata);
    data.append("staff_id", this.props.staff_id);
    var header = this.refs.request_api.header();
    var self = this;
    this.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/voos/arquivo', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var data_temp = self.state.staff_flight_files;
            data_temp.push(responseJson.data);
            self.setState({staff_flight_files: data_temp});
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
        console.error(error);
      });
    });   
  }


  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var staff_flight_file_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.deletar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/voos/arquivo/' + staff_flight_file_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          if (responseJson.status === 'success') {
            self.deletarLinha(staff_flight_file_id);
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(staff_flight_file_id) {
    var data = this.state.staff_flight_files;
    data.map(function(dado, index){
      if (dado.id == staff_flight_file_id) {
        data.splice(index, 1);
      }
    });
    this.setState({staff_flight_files: data});
  }

  botaoDownloadArquivo (cell, row) {
    var data = this.state.staff_flight_files;
    var status = '';
    var arquivo = '';
    var nome = '';
    data.map(function(dado, index){
      if (dado.id == cell) {
        arquivo = dado.archive;
        nome = dado.name;
      }
    });
    return (
      <a target="_blank" href={config.get('cdn') + '/files/staff_flights/' + arquivo}> {nome}</a>
    );
  }

  
  
  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tituloTotaisDeHoras}</h3>
  <hr/>
  <BootstrapTable data={this.state.flight_hours_totals} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.semAeronaves}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

    <TableHeaderColumn dataField="id" isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.ID}</TableHeaderColumn>
    <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.Modelo}</TableHeaderColumn>
    <TableHeaderColumn dataField="fb" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.FB}</TableHeaderColumn>
    <TableHeaderColumn dataField="total_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.Total}</TableHeaderColumn>
    <TableHeaderColumn dataField="ifr_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.IFR}</TableHeaderColumn>
    <TableHeaderColumn dataField="noturno_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.Noturno}</TableHeaderColumn>
    <TableHeaderColumn dataField="app" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.APP}</TableHeaderColumn>
    <TableHeaderColumn dataField="daytime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.Diurno}</TableHeaderColumn>
    <TableHeaderColumn dataField="nighttime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.Noturno}</TableHeaderColumn>
  </BootstrapTable>
  
  <Link className={'btn btn-primary btn-lg'} to={'/funcionario/horas/voos/' + this.state.id}>
    <i className="fa fa-fw fa-pencil"></i>{this.locale.general.editar}
  </Link>
  <hr/>
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tituloAdicionarArquivos}</h3>
  <hr/>
    <form onSubmit={this.adicionarArquivo}> 
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.formularioAdicionarArquivo.NomeDoArquivo}:</label>
            <input type="text" name="name" required className="form-control" placeholder={this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.formularioAdicionarArquivo.placeholder.NomeDoArquivo} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.formularioAdicionarArquivo.Arquivo}:</label>
            <input type="text" type="file" name="archive" className="form-control input-archive-flight-files" placeholder={this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.formularioAdicionarArquivo.placeholder.Arquivo} value={this.state.archive} onChange={this.handleChange.bind(this, 'archive')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-plus"></i> {this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.formularioAdicionarArquivo.botaoAdicionarArquivo}</button>
          </div>
        </div>
      </div>
    </form>
  <hr/>
  <BootstrapTable data={this.state.staff_flight_files} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaArquivos.semArquivos}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

    <TableHeaderColumn isKey={true} dataFormat={this.botaoDownloadArquivo} dataField="id" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaArquivos.NomeDoArquivo}</TableHeaderColumn>

    <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaArquivos.Validade}</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>{this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tabelaArquivos.Acoes}</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default StaffHoursTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffHoursTab.js